import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

const basicsplideOptions = {
  gap: 16,
  focus: 0,
  perMove: 1,
  pagination: true,
  arrows: false,
};
//owd基本Splide
function owdCarousel() {
  const setupSplide = (selector, perPage) => {
    const elms = document.querySelectorAll(selector);
    if (elms.length === 0) return;

    // 配列に変換してから処理
    Array.from(elms).forEach(elm => {
      // 重複防止チェック
      if (elm.classList.contains('is-initialized')) {
        return;
      }

      // 第1引数が必ずDOM要素であることを保証
      if (elm instanceof HTMLElement) {
        const splide = new Splide(elm, {
          ...basicsplideOptions,
          perPage: perPage,
        });
        splide.mount();

        // 初期化済みclassを付与
        elm.classList.add('is-initialized');
      }
    });
  };

  setupSplide('.owd-splide\\:default', 1.2);
  setupSplide('.owd-splide\\:UI', 2.4);
}

//owdオートプレイSplide
function owdCarouselAuto() {
    const owdAutoElms = document.querySelectorAll('.owd-splide\\:auto');
    if (owdAutoElms.length === 0) return;

    // 配列に変換してから処理
    Array.from(owdAutoElms).forEach(elm => {
      // 重複防止チェック
      if (elm.classList.contains('is-initialized')) {
        return;
      };
      if (!(elm instanceof HTMLElement)) return;

      const splide = new Splide(elm, {
        ...basicsplideOptions,
        perPage: 1.2,
        type: 'loop',
        autoplay: true,
        interval: 5000,
        pauseOnHover: false,// ホバーで停止させない
        pauseOnFocus: false // フォーカスで停止させない
      });

    splide.on('mounted', function () {
      const paginationList = splide.root.querySelector('.splide__pagination');
      if (!paginationList) return;
      // すでに停止ボタンがあるかチェック（二重生成防止）
      if (paginationList.querySelector('.autosplide-video-btn')) return;
      //新しいli要素を作成・ボタン要素を作成
      const customButtonLi = document.createElement('li');
      const videoButton = document.createElement('button');
      customButtonLi.className = 'autosplide-video-btn-wrap';
      videoButton.className = 'autosplide-video-btn';
      videoButton.setAttribute('aria-label', '自動再生を停止');
      // li の中に button を入れる
      customButtonLi.appendChild(videoButton);
      // ul の最後に li を追加
      paginationList.appendChild(customButtonLi);

      // ボタンのクリックイベント
      const Autoplay = splide.Components.Autoplay;
      // ボタンの外見を更新する関数
      const updateButtonUI = (isPaused) => {
        if (isPaused) {
          videoButton.classList.remove('is-playing');
          videoButton.setAttribute('aria-label', '自動再生を開始');
        } else {
          videoButton.classList.add('is-playing');
          videoButton.setAttribute('aria-label', '自動再生を停止');
        }
      };

      // クリックイベント
      videoButton.addEventListener('click', function() {
        if (Autoplay.isPaused()) {
          Autoplay.play();
        } else {
          Autoplay.pause();
        }
      });

      // Splideの状態変化を監視してUIを書き換え
      splide.on('autoplay:play', () => {
        console.log("自動再生を開始");
        updateButtonUI(false);
      });
      splide.on('autoplay:pause', () => {
        console.log("自動再生を停止");
        updateButtonUI(true);
      });
      // 初期状態反映
      updateButtonUI(!splide.options.autoplay);
    });
    splide.mount();
    elm.classList.add('is-initialized');
  });
}


export {owdCarousel,owdCarouselAuto};
